import { type ReactNode } from "react";
import { Header } from "./Header";
import { Sidebar, TopNav, type TabKey } from "./Sidebar";
import { FilterBar } from "./FilterBar";

interface AppShellProps {
  active: TabKey;
  onNavigate: (k: TabKey) => void;
  title: string;
  description?: ReactNode;
  environment?: string;
  mockMode?: boolean;
  generatedAt?: string;
  showFilterBar?: boolean;
  children: ReactNode;
}

export function AppShell({
  active, onNavigate, title, description, environment, mockMode,
  generatedAt, showFilterBar = true, children,
}: AppShellProps) {
  return (
    <div className="flex h-full flex-col">
      <Header environment={environment} mockMode={mockMode} generatedAt={generatedAt} />
      <TopNav active={active} onNavigate={onNavigate} />
      <div className="flex min-h-0 flex-1">
        <Sidebar active={active} onNavigate={onNavigate} />
        <main className="min-w-0 flex-1 overflow-y-auto">
          <div className="mx-auto flex max-w-[1600px] flex-col gap-4 p-5">
            <div>
              <h1 className="text-xl font-semibold tracking-tight text-fg">{title}</h1>
              {description && <p className="mt-1 text-sm text-fg-muted">{description}</p>}
            </div>
            {showFilterBar && <FilterBar />}
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
